<template>
    <div class="calc-column-text">
        <h1 class="big-size">{{ initialLeftText.title }}</h1>
        <p>{{ initialLeftText.text }}</p>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    props: {
        initialLeftText: {
            type: Object,
            required: true,
        }
    },
}
</script>
